import { format } from 'date-fns';

export function dateToInputString(date: Date | null | undefined, withTime: boolean) {
  if (date === undefined) return undefined;
  if (!date) return '';

  return format(date, withTime === true ? "yyyy-MM-dd'T'HH:mm" : 'yyyy-MM-dd');
}

export function toDateOrNull(value: string | number | Date | null | undefined): Date | null {
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : new Date(value);
  } else if (typeof value === 'number' || typeof value === 'string') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  } else {
    return null;
  }
}

export const maxDateOrNull = (...dates: (string | undefined | false | null | number | Date)[]): Date | null => {
  let max = null as Date | null;
  for (let date of dates) {
    if (!date && date !== 0) continue;

    if (typeof date === 'number' || typeof date === 'string') {
      date = new Date(date);
    }

    if (max === null || max < date) max = date;
  }

  return max;
};

export const minDateOrNull = (...dates: (string | undefined | false | null | number | Date)[]): Date | null => {
  let min = null as Date | null;
  for (let date of dates) {
    if (!date && date !== 0) continue;

    if (typeof date === 'number' || typeof date === 'string') {
      date = new Date(date);
    }

    if (min === null || min > date) min = date;
  }

  return min;
};
